module.exports = __webpack_public_path__ + "edec70695857267894a9bd59e9d0d3d9.pdf";